export const LOCALSTORAGE_KEY_USER = 'user';

export const ROLES = {
  user: 'role_user' as const,
  moderator: 'role_moderator' as const,
  admin: 'role_admin' as const,
};
